import type { RouteObject } from 'react-router-dom';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3401, { U3401ROLES } from './U3401';
import U3401StandaloneScreen from './components/U3401StandaloneScreen';

const U3401Routes: RouteObject[] = [
  {
    path: 'U3401',
    element: <U2000RequireRole allowedRoles={[U3401ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3401 />,
        children: [{ index: true, element: <U3401StandaloneScreen /> }],
      },
    ],
  },
];

export default U3401Routes;
